


























import Vue, { PropType } from 'vue';
import { v4 } from 'uuid';

export default Vue.extend({
  name: 'GCheckboxWorkForm',
  props: {
    isLabel: { type: Boolean as PropType<boolean>, default: true },
    isTag: { type: Boolean as PropType<boolean>, default: false },
    isPublic: { type: Boolean as PropType<boolean>, default: false },
    label: { type: String as PropType<string> },
    exclamation: { type: Array as PropType<string[]>, default: () => [] },
    name: { type: String as PropType<string>, required: true },
    // disabled: { type: Boolean as PropType<boolean>, default: false },
    isRequired: { type: Boolean as PropType<boolean>, default: false },
    isCheckBoxTwoLines: { type: Boolean as PropType<boolean>, default: false },
    value: { type: Array as PropType<number[]>, default: () => [] },
    rules: { type: [String, Object] as PropType<string | object>, default: '' },
  },
  computed: {
    vid(): string {
      return `${this.name}:${v4()}`;
    },
    innerValue: {
      get(): number[] {
        return this.value;
      },
      set(val: number[]): void {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    validate() {
      (this.$refs.gCheckboxWorkFormProvider as any).validate();
    },
  },
});
